// Copyright 2015-2023 Nstream, inc.
// All rights reserved.

import type {Class} from "@swim/util";
import {Model} from "@swim/model";
import {TraitModelRef} from "@swim/model";
import type {EntityTraitObserver} from "@nstream/domain";
import {EntityTrait} from "@nstream/domain";
import {AgentRelationTrait} from "../agent/AgentRelationTrait";
import {AppAspectTrait} from "./AppAspectTrait";

/** @public */
export interface AppEntityTraitObserver<T extends AppEntityTrait = AppEntityTrait> extends EntityTraitObserver<T> {
}

/** @public */
export class AppEntityTrait extends EntityTrait {
  appHost: string;

  constructor() {
    super();
    this.searchable.set(true);
    this.appHost = "";
  }

  declare readonly observerType?: Class<AppEntityTraitObserver>;

  @TraitModelRef({
    modelType: Model,
    modelKey: "portal",
    traitType: AppAspectTrait,
    traitKey: "aspect",
  })
  readonly portal!: TraitModelRef<this, AppAspectTrait>;

  @TraitModelRef({
    modelType: Model,
    modelKey: "agents",
    traitType: AgentRelationTrait,
    traitKey: "relation",
  })
  readonly agentsRelation!: TraitModelRef<this, AgentRelationTrait>;

  setAppHost(appHost: string): void {
    this.appHost = appHost;
  }

  protected override onStartSearching(): void {
    console.log("AppEntityTrait.onStartSearching");
  }

  protected override onStopSearching(): void {
    console.log("AppEntityTrait.onStopSearching");
  }

  override updateSearch(query: string): void {
    console.log("AppEntityTrait.updateSearch: " + query);
  }

  override submitSearch(query: string): void {
    console.log("AppEntityTrait.submitSearch: " + query);
  }
}
